import { useForm } from 'react-hook-form'
import { Switch } from '~/shadcn/ui/switch'
import { Spinner } from '~/shadcn/ui/spinner'
import { Form, FormField, FormItem } from '~/shadcn/ui/form/form'
import { FieldContent, FieldLabel } from '~/shadcn/ui/field'
import { useMarketingNotifications } from './useMarketingNotifications'
import { FormError } from '~/@mid_ui-form/form-error/FormError'
import { Button } from '~/shadcn/ui/button/button'

type FormModel = {
  isMarketingEnabled: boolean
}

type Props = {
  initialValues: FormModel
  onSuccess: () => void
}

function MarketingNotificationsSettingsForm({
  initialValues,
  onSuccess,
}: Props) {
  const {
    setMarketingNotifications: setMarketingNotificationsMutation,
    isSettingMarketingNotifications,
    error,
  } = useMarketingNotifications()

  const form = useForm<FormModel>({
    defaultValues: initialValues,
  })

  const handleSubmit = (values: FormModel) => {
    setMarketingNotificationsMutation(
      { isEnabled: values.isMarketingEnabled },
      {
        onSuccess,
      }
    )
  }

  const currentValue = form.watch('isMarketingEnabled')

  const canSubmitForm = (() => {
    return (
      currentValue !== initialValues.isMarketingEnabled &&
      !isSettingMarketingNotifications
    )
  })()

  return (
    <div className="w-full flex flex-col gap-10 last:flex-grow">
      <Form {...form}>
        <form onSubmit={form.handleSubmit(handleSubmit)}>
          <div className="flex flex-col items-start justify-between gap-8">
            <FormField
              control={form.control}
              name="isMarketingEnabled"
              render={({ field }) => (
                <FormItem>
                  <FieldContent className="flex flex-row-reverse md:flex-row justify-between items-center gap-4">
                    <Switch
                      id="isMarketingEnabled"
                      checked={field.value}
                      onCheckedChange={field.onChange}
                    />
                    <FieldLabel htmlFor="isMarketingEnabled">
                      <span className="text-base font-semibold leading-[26px]">
                        Súhlas so zasielaním všetkých informácií elektronicky
                        e-mailom
                      </span>
                    </FieldLabel>
                  </FieldContent>
                </FormItem>
              )}
            />

            <Button variant="accent" type="submit" disabled={!canSubmitForm}>
              Uložiť zmeny{` `}
              {isSettingMarketingNotifications && (
                <Spinner className="size-4" />
              )}
            </Button>

            {error && <FormError error={error} />}
          </div>
        </form>
      </Form>
    </div>
  )
}

export { MarketingNotificationsSettingsForm }
